
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"75b3279ab72ee798393315c06ae61c8ad4800125":"updateWorkspaceStore","ff647542b8dfe4280a5214603d5d8ef5dc53522e":"$$ACTION_0"} */ export var updateWorkspaceStore = createServerReference("75b3279ab72ee798393315c06ae61c8ad4800125");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

